import { useHotkeys } from '@mantine/hooks';
import { GLOBAL_SHORTCUTS } from '../../constants/shortcuts';
import { openSpotlight } from './events';

export function useSpotlightShortcuts() {
	useHotkeys([
		[
			GLOBAL_SHORTCUTS.SEARCH_PALETTE[0],
			() => openSpotlight({ type: 'search' }),
		],
		[
			GLOBAL_SHORTCUTS.COMMAND_PALETTE[0],
			() => {
				openSpotlight({ type: 'command' });
			},
		],
	]);
}
